import { Button as Button_RB, ButtonProps } from 'react-bootstrap';
import { useTheme } from 'styled-components';

interface BtProps extends ButtonProps {
  type?: 'button' | 'submit' | 'reset';
  onClick?: any;
  label: string;
  disabled?: boolean;
  botaoAzul?: boolean;
  botaoAmarelo?: boolean;
  botaoFiltros?: boolean;
  'data-testid'?: boolean | string;
}
function Button({
  type = 'button',
  onClick,
  label,
  disabled,
  botaoAzul,
  botaoAmarelo,
  botaoFiltros,
  'data-testid': dataTestId,
}: BtProps) {
  const theme = useTheme();

  const testId =
    typeof dataTestId === 'string'
      ? dataTestId
      : dataTestId === true
        ? `button-${label
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-') // espaços → hífen
            .replace(/[^a-z0-9-]/g, '')}` // remove caracteres estranhos
        : undefined;

  if (botaoAmarelo) {
    return (
      <Button_RB
        type={type}
        onClick={onClick}
        disabled={disabled}
        data-testid={testId}
        style={{
          borderColor: theme.colors.botaoLaranja,
          borderRadius: '10px',
          backgroundColor: theme.colors.botaoLaranja,
          color: theme.colors.white,
          fontSize: '14px',
        }}
      >
        {label}
      </Button_RB>
    );
  } else if (botaoFiltros) {
    return (
      <Button_RB
        type={type}
        onClick={onClick}
        disabled={disabled}
        data-testid={testId}
        style={{
          borderColor: theme.colors.botaoCinza,
          borderRadius: '10px',
          backgroundColor: theme.colors.botaoCinza,
          color: theme.colors.white,
          fontSize: '14px',
        }}
      >
        {label}
      </Button_RB>
    );
  } else {
    return (
      <Button_RB
        type={type}
        onClick={onClick}
        disabled={disabled}
        data-testid={testId}
        style={{
          borderRadius: '10px',
          backgroundColor: botaoAzul ? '#1351B4' : theme.colors.white,
          color: botaoAzul ? theme.colors.white : '#1351B4',
          fontSize: '14px',
        }}
      >
        {label}
      </Button_RB>
    );
  }
}

export default Button;
